import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import infoIcon from '@/assets/icons/info.svg'
import { ReactNode } from "react"

export const InputFieldWrapper = ({
  title,
  subtitle,
  infoContent,
  children
}: {
  title: string,
  subtitle?: string
  infoContent?: React.ReactNode,
  children?: ReactNode
}) => {
  return (
    <div className="w-full bg-foreground rounded-lg flex flex-col p-6">
      <div className="flex flex-row items-center justify-start min-w-0">
        <h2 className="text-primary font-semibold text-lg leading-2 mr-2 leading-6 truncate">
          {title}
        </h2>
        {infoContent && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="cursor-pointer" asChild>
                <img src={infoIcon} className="ml-2 hover:cursor" />
              </TooltipTrigger>
              <TooltipContent>
                {infoContent}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      {subtitle ? (
        <p className="text-primary text-left text-sm leading-4 mt-1 truncate">
          {subtitle}
        </p>
      ) : null}
      <div className="w-full bg-foreground min-w-0">
        {children}
      </div>
    </div>
  )
}
